module.exports = __webpack_public_path__ + "img/outlands.e14df9e7.jpg";